import React from 'react';
import { useSelector } from 'react-redux';
import { arClass } from '../../../utils/useArClass';

const StatCard = ({ label, value, icon, trend, color = "bg-white" }) => {
  const darkMode = useSelector((state) => state?.settings?.darkMode);

  const cardClasses = `${darkMode ? 'bg-slate-800 border-slate-700 text-slate-100' : `${color} border-slate-100 text-slate-800`} p-6 rounded-xl shadow-sm flex items-center justify-between`;
  const iconClasses = `${darkMode ? 'bg-slate-700 text-slate-300' : 'bg-slate-50 text-medical-600'} p-3 rounded-full`;
  const labelClasses = `${darkMode ? 'text-slate-400' : 'text-slate-500'} text-sm font-medium uppercase tracking-wide`;
  const valueClasses = `${darkMode ? 'text-slate-100' : 'text-3xl text-slate-800'} font-bold ${darkMode ? 'text-2xl' : 'text-3xl'}`;
  const trendClasses = `${darkMode ? 'text-green-400 bg-green-900/10' : 'text-green-600 bg-green-50'} text-xs mt-2 font-medium inline-block px-2 py-0.5 rounded-full`;

  return (
    <div className={arClass(`${cardClasses}`)}>
      <div>
        <p className={arClass(`${labelClasses}`)}>{label}</p>
        <h3 className={arClass(`${valueClasses} mt-1 max-sm:text-sm`)}>{value}</h3>
        {trend && <p className={arClass(`${trendClasses}`)}>{trend}</p>}
      </div>
      <div className={iconClasses}>
        {icon}
      </div>
    </div>
  );
};

export default StatCard;
